import { Box } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { Tooltip } from '@factorialco/f0-react/dist/experimental'
import { Add as AddIcon, Minus as MinusIcon } from '@factorialco/f0-react/icons/app'
import { ViewportHelperFunctionOptions, useReactFlow, useViewport } from '@xyflow/react'

import i18n from 'modules/core/lib/i18n'

const zoomingOptions: ViewportHelperFunctionOptions = { duration: 300 }

export const WorkflowZoom = () => {
  const { zoomIn, zoomOut, zoomTo } = useReactFlow()
  const { zoom } = useViewport()

  return (
    <Box
      className="absolute w-full z-50 flex flex-row gap-3 items-center justify-center"
      style={{ bottom: '10px' }}
    >
      <F0Button
        icon={AddIcon}
        label={i18n.t('workflows.zoom.in')}
        hideLabel
        variant="outline"
        size="md"
        onClick={() => zoomIn(zoomingOptions)}
      />
      <Box onClick={() => zoomTo(1, zoomingOptions)}>{(100 * zoom).toFixed(0)}%</Box>
      <F0Button
        icon={MinusIcon}
        label={i18n.t('workflows.zoom.out')}
        hideLabel
        variant="outline"
        size="md"
        onClick={() => zoomOut(zoomingOptions)}
      />
    </Box>
  )
}
